<template>
  <div class="map-fluid is-fullheight is-border-left is-border-right is-border-bottom is-padding-xsmall has-bg-white vadimmStockMapVue" id="lots-carte">
    <div class="loader-overlay is-radius-large"
          v-if="loading" id="map-loader-overlay">
      <spinner-round :loading="loading" v-if="loading"></spinner-round>
      <div class="columns is-vcentered is-min-height-full" v-if="!loading && (!programs || !programs.length)">
        <div class="column has-text-centered">
          <h1 class="title is-2 is-paddingless-bottom is-margin-bottom-small has-text-black">Aucun résultat</h1>
          <p class="is-paddingless-top is-margin-top-small has-text-black">Changez vos critères de filtrage</p>
        </div>
      </div>
    </div>
    <div class="vue-map-container" v-if="google">
      <gmap-map ref="gmap" :center="center" :zoom="zoom" :options="mapOptions" @zoom_changed="zoomChanged" @bounds_changed="boundsChanged" style="height: 100%">
        <gmap-polygon v-for="r in regionsList" :key="r.value"
                      v-if="regionMode"
                      :editable="false"
                      :path="regionsPath(r)"
                      :options="polygonsOptions" :clickable="true" />
        <gmap-cluster v-if="!loading && !regionMode" @click="zoomOnCluster">
          <gmap-marker v-for="p in localisablePrograms" :key="p.pk"
                        :icon="{ url: `static/icons/marker.png`, size: new google.Size(145, 145), scaledSize: new google.Size(50, 50), anchor: new google.Point(25, 25) }"
                        :position="{lat: p.location.latitude, lng: p.location.longitude}" :clickable="true"
                        @click="openWindowInfo(p)">
          </gmap-marker>
          <gmap-info-window @closeclick="windowInfoOpened = false; program = null; programLotCount = null"
                            :opened="windowInfoOpened"
                            :position="windowInfoPos"
                            v-if="windowInfoOpened">
            <program-card :stock="program" :map-card="true" v-if="program" class="card map-info map-info--large"></program-card>
          </gmap-info-window>
        </gmap-cluster>
        <gmap-cluster v-if="!loading && regionMode" v-for="r in programs" :key="r.name"
                        @click="regionFilter(r.codes, $event)">
          <gmap-marker v-for="p in r.count" :key="p" :label="`${r.count}`"
                        @click="regionFilter(r.codes, $event)"
                        :position="{lat: r.center.latitude, lng: r.center.longitude}">
          </gmap-marker>
        </gmap-cluster>
      </gmap-map>
    </div>
  </div>
</template>

<script>
  import { DefaultValues } from '@/mixins'
  import { gmapApi } from 'vue2-google-maps'
  import { mapGetters } from 'vuex'
  import ProgramCard from './StockProgramCard'
  import { cleanQuery } from '@/utils'
  import { debounce } from 'lodash'

  export default {
    name: 'StockMapGoogle',
    mixins: [DefaultValues],
    components: {ProgramCard},
    data () {
      return {
        zoom: 13,
        bounds: {},
        windowInfoOpened: false,
        windowInfoPos: {lat: 0, lng: 0},
        program: null,
        programLotCount: null,
        lotCount: 0,
        regionMode: true,
        polygonsOptions: {
          zIndex: 2,
          strokeColor: '#8c8c8c',
          strokeOpacity: 1,
          strokeWeight: 1,
          fillColor: '#bebebe',
          fillOpacity: 0
        }
      }
    },
    props: {
      sourceProgramsMap: {
        type: Object
      },
      filters: {
        type: Object
      },
      mapLoading: {
        type: Boolean
      }
    },
    watch: {
      loading (v) {
        if (!v) {
          this.initMapBounds()
        }
      },
      '$refs.gmap' (v) {
        this.initMapBounds()
      },
      programs (v) {
        this.initMapBounds()
      }
    },
    computed: {
      ...mapGetters(['isDistributeurMode']),
      center () {
        if (this.$configs.COUNTRY !== 'FRA') {
          return {lat: 46.1445466, lng: 2.4343558}
        } else {
          return {lat: 31.4650675, lng: -9.1811334}
        }
      },
      loading () {
        return this.mapLoading
      },
      programs () {
        this.regionMode = this.sourceProgramsMap.regionMode
        return this.sourceProgramsMap.data
      },
      mapOptions () {
        if (this.google) {
          return {
            streetViewControl: false,
            styles: this.mapStyle,
            fullscreenControl: false,
            maxZoom: 17,
            zoomControlOptions: {position: this.google.ControlPosition.RIGHT_TOP}
          }
        }
      },
      google () {
        if (gmapApi && gmapApi() && gmapApi().maps) {
          return gmapApi().maps
        }
      },
      localisablePrograms () {
        if (this.programs && this.programs.length) {
          return this.programs.filter(p => {
            if (this.$configs.COUNTRY === 'FRA') {
              if (p.location && p.location.longitude && p.location.latitude && p.address.country.toLowerCase() === 'france') {
                return true
              }
            } else {
              if (p.location && p.location.longitude && p.location.latitude) {
                return true
              }
            }
            return false
          })
        }
      },
      lotListUrl () {
        let query = {
          nature: this.filters.nature,
          lot_type: this.filters.lot_type,
          date_livraison: this.filters.date_livraison,
          surface__gte: this.filters.surface__gte,
          surface__lte: this.filters.surface__lte,
          sale_price__gte: this.filters.sale_price__gte,
          sale_price__lte: this.filters.sale_price__lte,
          state: this.filters.state
        }
        Object.assign(query, this.$route.query)
        return {name: 'StockLots', query: query}
      },
      currentProgramUrl () {
        let url = this.lotListUrl
        url.query.program = this.program.program
        return url
      }
    },
    methods: {
      zoomChanged (val) {
      },
      boundsChanged (val) {
      },
      historySave: debounce(function () {
        let query = {
          ...this.filters,
          zoom: this.zoom,
          bounds: this.bounds
        }
        let queryString = cleanQuery(query)
        history.pushState(null, null, `#${this.$route.path}?${queryString}`)
      }, 500),
      zoomOnCluster (cluster) {
        let bounds = cluster.bounds_
        this.zoomOnMap(bounds)
      },
      zoomOnMap (bounds) {
        this.$refs.gmap.$mapPromise.then(() => {
          this.$refs.gmap.fitBounds(bounds)
          this.$refs.gmap.panToBounds(bounds)
        })
      },
      openWindowInfo (p) {
        this.program = p
        this.programLotCount = null
        this.windowInfoPos = {lat: p.location.latitude, lng: p.location.longitude}
        this.windowInfoOpened = true
      },
      goToLink () {
        this.$emit('updateProgramFilter', this.program.program)
        this.$router.push(this.currentProgramUrl)
      },
      regionFilter (v, e) {
        this.$emit('updateStateFilter', v)
      },
      initMapBounds (init = false) {
        if (!this.$gmapApiPromiseLazy || typeof this.$gmapApiPromiseLazy !== 'function') return
        this.$gmapApiPromiseLazy().then(() => {
          if (!this.programs || (this.programs && !this.programs.length)) return
          if (!this.google) return
          let bounds = new this.google.LatLngBounds()
          this.programs.forEach((x, i) => {
            if (this.regionMode) {
              if (x.center.latitude && x.center.longitude) {
                bounds.extend(new this.google.LatLng(x.center.latitude, x.center.longitude))
              }
            } else {
              if (x.location.latitude && x.location.longitude) {
                bounds.extend(new this.google.LatLng(x.location.latitude, x.location.longitude))
              }
            }
            if (i === this.programs.length - 1) {
              this.zoomOnMap(bounds)
            }
          })
        })
      },
      regionsPath (region) {
        if (region && region.coordinates && region.coordinates[0]) {
          return region.coordinates[0].map(x => {
            return {lng: x[0], lat: x[1]}
          })
        }
      }
    },
    mounted () {
      this.initMapBounds(true)
    }
  }
</script>

<style lang="sass">
// https://codepen.io/Marnoto/pen/xboPmG  A tester
#lots-carte.map-fluid
  .gm-style-iw
    top: 10px !important
    left: 10px !important
  .gm-style
    .gm-style-iw-t
      &:after
        top: inherit
        bottom: -25px
  .card.map-info
    border: 0
    &.map-info--large
      // width: 630px
      max-width: 100%
      width: 65vw
  .card-header-icon
    display: none
  .card-content
    padding-bottom: 0

    .gm-style 

</style>




// WEBPACK FOOTER //
// src/components/stock/StockMapGoogle.vue